const IMAGE_EXT = /\.(jpe?g|png|gif|webp|bmp|svg)(\?|$)/i;

const decodeHtml = (value) => String(value || '')
	.replace(/&amp;/g, '&')
	.replace(/&quot;/g, '"')
	.replace(/&#039;/g, "'")
	.replace(/&lt;/g, '<')
	.replace(/&gt;/g, '>');

const isImageFile = (name, url, flagged) => {
	if (flagged) return true;
	return IMAGE_EXT.test(name || '') || IMAGE_EXT.test(url || '');
};

/**
 * Pull Claritask file markup out of a synced comment so Claritick can render
 * it with ConversationAttachments (100px thumbs) instead of full-size images.
 */
export const splitClaritaskCommentFiles = (comment) => {
	let content = typeof comment?.content === 'string' ? comment.content : '';
	const attachments = [];
	const seen = new Set();

	const push = (url, name, flaggedImage) => {
		const public_url = decodeHtml(url).trim();
		if (!public_url || seen.has(public_url)) return;
		seen.add(public_url);
		const filename = decodeHtml(name).replace(/<[^>]+>/g, '').trim() || 'attachment';
		const image = isImageFile(filename, public_url, flaggedImage);
		attachments.push({
			id: `ct-${comment?.id || 'file'}-${attachments.length}-${filename}`,
			name: filename,
			public_url,
			mime_type: image ? 'image/jpeg' : 'application/octet-stream',
		});
	};

	content = content.replace(/<a\b[^>]*class="comment-file"[^>]*>[\s\S]*?<\/a>/gi, (anchor) => {
		const href = (anchor.match(/href="([^"]+)"/i) || [])[1] || '';
		const fromP = (anchor.match(/<p[^>]*>([\s\S]*?)<\/p>/i) || [])[1] || '';
		const fromAlt = (anchor.match(/alt="([^"]+)"/i) || [])[1] || '';
		push(href, fromP || fromAlt, /<img\b/i.test(anchor));
		return '';
	});

	content = content.replace(/<img\b[^>]*>/gi, (img) => {
		push(
			(img.match(/src="([^"]+)"/i) || [])[1] || '',
			(img.match(/alt="([^"]+)"/i) || [])[1] || '',
			true
		);
		return '';
	});

	const raw = comment?.attachments;
	const extra = Array.isArray(raw)
		? raw
		: (raw && (raw.file_full || raw.public_url) ? [raw] : []);
	extra.forEach((file) => {
		push(
			file.public_url || file.file_full || file.thumb,
			file.name || file.filename,
			file.is_image || (typeof file.mime_type === 'string' && file.mime_type.includes('image/'))
		);
	});

	content = content
		.replace(/(?:<br\s*\/?>\s*)+$/gi, '')
		.replace(/<p>\s*<\/p>/gi, '')
		.trim();

	return { content, attachments };
};

/** Bold the person after "by" in Claritask task-status notes. */
export const emphasizeClaritaskNoteActor = (html) => {
	if (typeof html !== 'string' || html === '') return html;
	if (/to\s+<strong>[\s\S]*?<\/strong>\s+by\s+<strong>/i.test(html)) return html;
	return html.replace(
		/(to\s+<strong>[\s\S]*?<\/strong>\s+by\s+)(?!<strong>)([^<]+?)(\.?)\s*$/i,
		(_, prefix, name, period) => `${prefix}<strong>${String(name).trim()}</strong>${period || ''}`
	);
};
